import { default as React, ReactNode } from "react";
import { Helmet } from "react-helmet";
import Head from "../../components/Head/Head";
import { PageMetadata } from "../../model/metadata";

import { SkipNavContent, SkipNavLink } from "@reach/skip-nav";
import "@reach/skip-nav/styles.css";
import Footer from "../../components/Footer/Footer";
import SiteNav from "../../components/SiteNav/SiteNav";
import { GlobalMenus } from "../../model/menu";
import { PageMetadataProvider } from "../../utils/usePageMetadata";
import styles from "./PageLayoutContent.module.scss";
import { useScrollTracking } from "../../utils/useScrollTracking";

export interface PageLayoutContentProps {
  menus: GlobalMenus;
  children: ReactNode;
  metadata: PageMetadata;
  isErrorPage?: boolean;
}

const PageLayoutContent = ({
  children,
  metadata,
  menus,
  isErrorPage = false
}: PageLayoutContentProps) => {
  useScrollTracking();
  const language = metadata.page.language || "en";
  return (
    <>
      <PageMetadataProvider metadata={metadata}>
        <Helmet
          htmlAttributes={{
            lang: language,
            dir: dirForLanguage(language)
          }}
        />
        <Head metadata={metadata} />
        {/* Regular survey slot: <ExternalSurveyPopup /> */}
        <div className={styles.root}>
          <SkipNavLink className={styles.skipNavLink} />
          <SiteNav
            menus={menus}
            metadata={metadata}
            isErrorPage={isErrorPage}
          />
          <SkipNavContent />
          <div className={styles.content}>{children}</div>
          <div className={styles.footer}>
            <Footer menus={menus} />
          </div>
        </div>
        {/* <BottomRightPrompt /> */}
      </PageMetadataProvider>
    </>
  );
};

export default PageLayoutContent;

const dirForLanguage = (language: string): string | undefined => {
  switch (language) {
    case "ar":
      return "rtl";
    default:
      return "ltr";
  }
};
